<div>
  <div class="basics">
    <div class="wrap">
      <span>Computation Name:</span> <input bind:value={value['meta']['name']} />
    </div>
    <div class="wrap">
      <span>Id:</span> <input bind:value={value['meta']['id']} />
    </div>
    <div class="wrap">
      <span>GIT Repository URL:</span> <input bind:value={value['meta']['repository']} />
    </div>
    <div class="wrap">
      <span>Description:</span> <input bind:value={value['meta']['description']} />
    </div>
    <div class="wrap">
      <span>Docker Image Path:</span> <input bind:value={value['computation']['dockerImage']} />
    </div>
    <div class="wrap">
      <DisplaySelect bind:value={value['computation']['display']['type']} />
    </div>
  </div>
</div>

<script>
  import DisplaySelect from './DisplaySelect.svelte';

  export let value;
</script>

<style>
	.basics {
		background: #efefef;
    padding-bottom: 1.5rem;
	}
	.wrap-item {
		display: flex;
		justify-content: space-around;
		align-items: center;
		background: #efefef;
	}
	.wrap-item a {
		padding: 0 1rem 0 0;
	}
	.wrap {
	  padding: 1rem 1rem 0;
		background: #efefef;
	}
  .wrap.column {
    flex-direction: column;
	}
	.wrap > .wrap {
		padding: 0;
		margin-right: 1rem;
	}
	.wrap span {
		display: inline-block;
		margin-right: 0.5rem;
	}
  .wrap input {
		width: 100%
	}
	.close {
		margin: 0;
	}
	input, textarea {
		width: 100%;
	}
</style>
